import React from "react";
import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";
import GoldDivider from "../components/GoldDivider";

const stats = [
    { v: "$3.4B", l: "Closed volume" },
    { v: "22+", l: "Years in Las Vegas" },
    { v: "180", l: "Trophy transactions" },
    { v: "42", l: "Countries represented" },
];

const About = () => (
    <div data-testid="page-about">
        <section className="relative pt-44 pb-28 overflow-hidden">
            <div
                className="absolute inset-0 opacity-40"
                style={{
                    backgroundImage:
                        "url(https://images.unsplash.com/photo-1765323337815-1b1c1a47cdaa?auto=format&fit=crop&w=1800&q=80)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/70 to-brand-jet" />
            <div className="relative max-w-5xl mx-auto px-6 text-center">
                <Reveal>
                    <p className="text-[0.7rem] tracking-[0.55em] uppercase text-brand-gold mb-6">The Firm</p>
                    <h1 className="font-serif-editorial text-5xl md:text-6xl lg:text-7xl text-brand-silver leading-[1.05]">
                        Quiet power. <span className="italic text-brand-champagne">Uncompromising</span> standards.
                    </h1>
                    <p className="mt-10 text-brand-silver/75 text-lg max-w-2xl mx-auto leading-relaxed">
                        Real Estate &amp; Administration Inc was founded to serve a narrow mandate: represent
                        the most discerning commercial institutions and private households in Las Vegas with
                        a level of care the market had forgotten.
                    </p>
                </Reveal>
            </div>
        </section>

        <section className="py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-12 gap-16 items-start">
                <div className="md:col-span-5">
                    <Reveal>
                        <p className="text-[0.7rem] tracking-[0.45em] uppercase text-brand-gold mb-6">Philosophy</p>
                        <h2 className="font-serif-editorial text-3xl md:text-5xl text-brand-silver leading-tight">
                            The market you see is not the market we broker.
                        </h2>
                    </Reveal>
                </div>
                <div className="md:col-span-7 space-y-8">
                    {[
                        { h: "Discretion", p: "We routinely represent properties that never appear on public MLS. Our clients expect privacy — we deliver it by protocol." },
                        { h: "Administration", p: "Every transaction is administered end-to-end: underwriting, diligence, negotiation, closing, and post-close stewardship." },
                        { h: "Global Capital", p: "Active relationships with family offices in Monaco, Zurich, Dubai, Hong Kong, and São Paulo routing capital into Southern Nevada." },
                        { h: "Fidelity", p: "We represent one side, well. No dual agency, no engineered bidding wars. Your interests — surgically served." },
                    ].map((b, i) => (
                        <Reveal key={b.h} delay={i * 100}>
                            <div className="grid grid-cols-12 gap-6 pb-8 border-b border-white/5">
                                <div className="col-span-4 md:col-span-3 text-[0.7rem] tracking-[0.4em] uppercase text-brand-gold pt-1">
                                    0{i + 1}
                                </div>
                                <div className="col-span-8 md:col-span-9">
                                    <h3 className="font-serif-editorial text-2xl text-brand-champagne">{b.h}</h3>
                                    <p className="mt-3 text-brand-silver/70 leading-relaxed">{b.p}</p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>

        <GoldDivider />

        <section className="py-24 md:py-32 bg-brand-onyx/40">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-2 md:grid-cols-4 gap-10">
                {stats.map((s, i) => (
                    <Reveal key={s.l} delay={i * 100} className="text-center md:text-left">
                        <div className="font-serif-editorial text-5xl md:text-6xl lg:text-7xl gold-shimmer leading-none">
                            {s.v}
                        </div>
                        <div className="mt-4 text-[0.7rem] tracking-[0.4em] uppercase text-brand-silver/60">{s.l}</div>
                    </Reveal>
                ))}
            </div>
        </section>

        <section className="py-28 md:py-36">
            <div className="max-w-3xl mx-auto text-center px-6">
                <Reveal>
                    <p className="font-cursive text-brand-gold text-5xl wordmark-glow">Privately introduced.</p>
                    <p className="mt-6 text-brand-silver/70 max-w-xl mx-auto">
                        New client relationships are accepted by introduction or formal inquiry.
                    </p>
                    <Link
                        to="/contact"
                        className="mt-10 inline-flex text-xs tracking-[0.35em] uppercase border border-brand-gold text-brand-gold px-10 py-5 hover:bg-brand-gold hover:text-brand-jet transition-all duration-500"
                        data-testid="about-cta-contact"
                    >
                        Begin a conversation
                    </Link>
                </Reveal>
            </div>
        </section>
    </div>
);

export default About;
